<template>
  <PortableText
    v-if="insideLayoutPortableText"
    :portable-data="insideLayoutPortableText"
  />
</template>

<script lang="ts" setup>
import PortableText from '~/components/Atmos/PortableText/PortableText.vue';
import type { InsideLayoutPortableText } from '~/sanity/types';
defineProps<InsideLayoutPortableText>();
</script>

<style lang="scss" scoped></style>
